import { render, staticRenderFns } from "./VendeurCategoryLabel.vue?vue&type=template&id=952f5fce&scoped=true&"
import script from "./VendeurCategoryLabel.vue?vue&type=script&lang=ts&"
export * from "./VendeurCategoryLabel.vue?vue&type=script&lang=ts&"
import style0 from "./VendeurCategoryLabel.vue?vue&type=style&index=0&id=952f5fce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952f5fce",
  null
  
)

export default component.exports